import { LifecycleStoreTask } from "@/store/Lifecycle/types";
import { StageTaskType } from "@/store/Lifecycle/constants";
import { TaskProvider } from "../../../taskComponents/Provider";
import UserIdTask from "../../../taskComponents/UserIdTask";

interface UserIdsSectionProps {
    tasks: LifecycleStoreTask<StageTaskType.UserId>[];
}
const UserIdsSection = ({ tasks }: UserIdsSectionProps) => {
    return (
        <div className="user-ids-section">
            {tasks.map((infoCardTask, i) => (
                <TaskProvider key={i} task={infoCardTask}>
                    <UserIdTask />
                </TaskProvider>
            ))}
        </div>
    )
}

export default UserIdsSection;